/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "model": {
            "nested": {
              "InventoryUnit": {
                "fields": {
                  "productName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sku": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "serialNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE InventoryUnit @ squareup/solidshop/model/inventory_unit.proto at 8:1
 */
export const InventoryUnit = $root.lookupType('squareup.solidshop.model.InventoryUnit');
fixType(InventoryUnit);
Builder.createAndAttachToType(InventoryUnit);
